import { ParticipantsProvider } from "./ParticipantsContext.js";
import ParticipantsView from "./ParticipantsView.js";

const ParticipantsIndex = () => {
  return (
    <ParticipantsProvider>
      <ParticipantsView />
    </ParticipantsProvider>
  );
};
export default ParticipantsIndex; 
